import {inject, Injectable, signal} from '@angular/core';
import {ProductPackagesModalService} from "./product-packages-modal.service";
import {GetSelectDataParams, SelectData} from "../../../../../../core/types/records-table.types";
import {
  articleOzonPropertyLazySelect,
  articleWBPropertyLazySelect,
  placePropertyLazySelect, propertyLazySelectPalletType,
  propertyLazySelectProductPackageType
} from "../configs/lazy-select-data-params";
import {ProductPackagesDialogData} from "../types/product-packages-modal.types";

@Injectable({
  providedIn: 'root'
})
export class ProductPackagesSelectDataStateService {
  private productPackageModalService: ProductPackagesModalService = inject(ProductPackagesModalService);

  private _packageTypeSelectData = signal<Array<SelectData>>([]);
  private _storageLocationSelectData = signal<Array<SelectData>>([]);
  private _articleWBSelectData = signal<Array<SelectData>>([]);
  private _articleOzonSelectedData = signal<Array<SelectData>>([]);
  private _palletTypeSelectData = signal<Array<SelectData>>([]);
  public packageTypeSelectData = this._packageTypeSelectData.asReadonly();
  public storageLocationSelectData = this._storageLocationSelectData.asReadonly();
  public articleWBSelectData = this._articleWBSelectData.asReadonly();
  public articleOzonSelectedData = this._articleOzonSelectedData.asReadonly();
  public palletTypeSelectData = this._palletTypeSelectData.asReadonly();

  public async fetchSelectData(data: ProductPackagesDialogData): Promise<void> {
    const { parentId, modalKey } = data;
    await this.setPackageTypeSelectData();
    await this.setStorageLocationSelectData();
    await this.setArticleWBSelectData(parentId);
    await this.setArticleOzonSelectData(parentId);
    modalKey === 'palletModalDto' && await this.setPalletTypeSelectData();
  }

  public getSelectDataByKey(key: string): Array<SelectData> {
    const selectData: Record<string, () => Array<SelectData>> = {
      packageType: () => this.packageTypeSelectData(),
      storageLocationType: () => this.storageLocationSelectData(),
      nmId: () => this.articleWBSelectData(),
      sku: () => this.articleOzonSelectedData(),
      palletType: () => this.palletTypeSelectData()
    };

    return selectData[key]?.() || [];
  }

  private async setPackageTypeSelectData(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: propertyLazySelectProductPackageType
    };

    await this.productPackageModalService.fetchSelectData(getSelectDataParams)
      .then((data) => this._packageTypeSelectData.set(data));
  }

  private async setStorageLocationSelectData(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: placePropertyLazySelect
    };

    await this.productPackageModalService.fetchSelectData(getSelectDataParams)
      .then((data) => this._storageLocationSelectData.set(data));
  }

  private async setArticleWBSelectData(parentId: number): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: articleWBPropertyLazySelect,
      id: parentId
    };

    await this.productPackageModalService.fetchSelectData(getSelectDataParams)
      .then((data) => this._articleWBSelectData.set(data));
  }

  private async setArticleOzonSelectData(parentId: number): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: articleOzonPropertyLazySelect,
      id: parentId
    };

    await this.productPackageModalService.fetchSelectData(getSelectDataParams)
      .then((data) => this._articleOzonSelectedData.set(data));
  }

  private async setPalletTypeSelectData(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: propertyLazySelectPalletType
    };

    await this.productPackageModalService.fetchSelectData(getSelectDataParams)
      .then((data) => this._palletTypeSelectData.set(data));
  }
}
